import { get } from 'lodash/object';
import logOut from '%paysera_admin/js/axios/interceptor/response/redux-unauthorized';

export default class UnauthorizedMiddleware {
    onResponseError(error) {
        if (get(error, 'response.status') === 401) {
            logOut();
            // eslint-disable-next-line no-param-reassign
            error.mute = true;
        }
        if (get(error, 'response.status') === 403) {
            // eslint-disable-next-line no-param-reassign
            error.mute = true;
        }

        return Promise.reject(error);
    }
}
